module.exports = __webpack_public_path__ + "static/media/check-mark.3ffd2200.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/check-mark.svg
// module id = 152
// module chunks = 1